<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  getWorkflowStageMeta,
  getWorkflowStageLabel,
} from 'dashboard/helper/workflowStageHelper';

const props = defineProps({
  workflowStage: { type: String, default: 'open' },
  workflowType: { type: String, default: 'bug' },
});

const meta = computed(() => getWorkflowStageMeta(props.workflowStage));
const tooltipLabel = computed(() =>
  getWorkflowStageLabel(props.workflowStage, props.workflowType)
);
</script>

<template>
  <span
    v-tooltip.top="{ content: tooltipLabel, delay: { show: 300, hide: 0 } }"
    class="flex items-center justify-center rounded-full flex-shrink-0 size-5"
    :class="[meta.badgeClass, meta.urgent ? 'ring-2 ring-n-ruby-9' : '']"
  >
    <Icon :icon="meta.icon" class="size-3" />
  </span>
</template>
